module.exports = __webpack_public_path__ + "img/img6.62be7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img6.png
// module id = 399
// module chunks = 0